import { ILocation } from "../interfaces/ILocation";
import { CrudService } from "./crudService";
import { IPagedFilterRequest } from "../interfaces/IPagedFilterResults";
import { IPagedFilterResponse } from "../interfaces/IPagedFilterResponse";
import { buildPagedFilterQuery } from "../utils/queryHelpers";
import { ILocationStats } from "../interfaces/ILocationStats";
import { IEventList } from "../interfaces/IEventList";
import { ILocationAnalytics } from "../interfaces/ILocationAnalytics";
import { IRoomStats } from "../interfaces/IRoomStats";
import { IAiInsights } from "./dashboardService";

export class LocationService extends CrudService<ILocation> {
    constructor(apiClient: any) {
        super(apiClient, '/admin/location');
    }

    // Override getAll for paginated fetching of ILocationList
    async getAllLocation(request: IPagedFilterRequest): Promise<IPagedFilterResponse<ILocation>> {
        try {
            const query = buildPagedFilterQuery(request);
            const response = await this.apiClient.get(`${this.endpoint}/paged?${query}`);
            return response.data;
        } catch (error: any) {
            throw new Error(error.response ? error.response.data : 'An error occurred');
        }
    }

    async getLocationStats(locationId: string): Promise<ILocationStats> {
        try {
            const response = await this.apiClient.get(`${this.endpoint}/${locationId}/stats`);
            return response.data;
        } catch (error: any) {
            throw new Error(error.response ? error.response.data : 'An error occurred');
        }
    }

    async getAllLocationEvents(locationId: string, request: IPagedFilterRequest): Promise<IPagedFilterResponse<IEventList>> {
        try {
            const query = buildPagedFilterQuery(request);
            const response = await this.apiClient.get(`${this.endpoint}/${locationId}/events?${query}`);
            return response.data;
        } catch (error: any) {
            throw new Error(error.response ? error.response.data : 'An error occurred');
        }
    }

    async getLocationAnalytics(locationId: string): Promise<ILocationAnalytics> {
        try {
            const response = await this.apiClient.get(`${this.endpoint}/${locationId}/analytics`);
            return response.data;
        } catch (error: any) {
            throw new Error(error.response ? error.response.data : 'An error occurred');
        }
    }
    async getRoomStats(locationId: string, roomId: string): Promise<IRoomStats> {
        try {
            const response = await this.apiClient.get(`${this.endpoint}/${locationId}/room/${roomId}/stats`);
            return response.data;
        } catch (error: any) {
            throw new Error(error.response ? error.response.data : 'An error occurred');
        }
    }

    async getLocationAiInsights(locationId: string): Promise<IAiInsights> {
        try {
            const response = await this.apiClient.get(`${this.endpoint}/${locationId}/ai-insights`);
            return response.data;
        } catch (error: any) {
            throw new Error(error.response ? error.response.data : 'An error occurred');
        }
    }
}
